import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Alert from "../../shared/Alerts"

export default function View(props) {
        return(
            <>

                {/* Login */}

                <div className = "login" style={{padding : 0}}>
                    <main className="form-login">
                        <div className="dropdown text-end">
                            <div className="p-2">

                                {/* Dropdown button */}
                                
                                <Dropdown>
                                    <Dropdown.Toggle variant="Primary" id="dropdown-basic" style={{color:'white'}}>
                                        {props.displayLang}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={props.selectedLanguage} aria-valuenow="3">Français</Dropdown.Item>
                                        <Dropdown.Item onClick={props.selectedLanguage} aria-valuenow="5">Español</Dropdown.Item>
                                        <Dropdown.Item onClick={props.selectedLanguage} aria-valuenow="4">Català</Dropdown.Item>
                                        <Dropdown.Item onClick={props.selectedLanguage} aria-valuenow="2">English</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/* Dropdown button */}

                            </div>
                        </div>
                        
                        {/* Login Form */}

                        {!props.forgetPass && <div className = "row">
                            <section className="form">
                                <form onSubmit={props.handleSubmit}>
                                    <h1 className="mb-3 text-center"><img className="img-fluid" src="https://webapp.blinkay.app/integraMobile/Content/img/Blinkay-login.svg" width="300" height="81" alt="log in to blinkay"></img></h1>
                                    
                        {/* Metrial Alert */}
                                    
                                    {props.error && 
                                        <Alert
                                            error = {props.error}
                                            msg = {props.msg}
                                        />
                                    }

                        {/* Metrial Alert */}

                                    <div className="form-floating mb-3 ps-0">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="floatingInput" 
                                            name = "username" 
                                            value = {props.formData.username || ''}
                                            onChange={props.handleChange}
                                            placeholder="name@example.com" autoFocus
                                            ></input>
                                        <label 
                                            htmlFor="floatingInput" 
                                            className="text-secondary ps-0">
                                            <ion-icon className="text-primary" name="person-outline"></ion-icon>
                                            {props.sheetData.EmailAddress}
                                            </label>
                                            {props.formData.username === '' && 
                                                <p style = {{color:'red'}}>
                                                    {props.sheetData.UsernameIsRequired}
                                                </p>}
                                    </div>
                                    <div className="form-floating ps-0">
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            id="floatingPassword" 
                                            placeholder="Password"
                                            value = {props.formData.password  || ''}
                                            name = "password"
                                            onChange={props.handleChange}
                                            ></input>
                                        <label 
                                            htmlFor="floatingPassword" 
                                            className="text-secondary ps-0">
                                            <ion-icon className="text-primary" name="lock-closed-outline"></ion-icon>
                                            {props.sheetData.Password}
                                            </label>
                                            {props.formData.password === '' && 
                                                <p style = {{color:'red'}}>
                                                    {props.sheetData.PasswordIsRequired}
                                                </p>}
                                    </div>
                                    <div className="row">
                                        <div className="col-5">
                                            <div className="checkbox mb-3 mt-2 text-secondary">
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    name = "rememberMe"  
                                                    checked={props.formData.rememberMe}                                              
                                                    onChange={props.handleCheckChange}
                                                    ></input> 
                                                    <small> {props.sheetData.RememberMe}</small>
                                            </label>
                                            </div>
                                        </div>
                                        <div className="col-7 mt-2 text-end">
                                            <a 
                                                
                                                onClick={props.enableForgetPassword}
                                                style={{cursor : 'pointer',
                                                    color : '#034fc7'}}
                                            >
                                                <small>{props.sheetData.ForgetPassword}</small>
                                                </a>
                                        </div>
                                    </div>
                                    <button 
                                        className="w-100 btn btn-lg bk-btn-primary mt-5" 
                                        type="submit"
                                        disabled = {props.formData.username === undefined 
                                                    || props.formData.username === ''
                                                    || props.formData.password === null
                                                    || props.formData.password === ''}>
                                            {props.sheetData.Login}
                                            </button>
                                        <p className="text-center mt-2">
                                            <small>{props.sheetData.NotAccountYet}
                                                <a href="#"> {props.sheetData.RegisterHere}</a>
                                            </small>
                                        </p>
                                </form> 
                            </section>                             
                        </div>}

                        {/* Login Form */}

                        
                        {/* Forget Password Form */}
                        
                        {props.forgetPass && 
                            <section class="form form-forgot-pw">
                                <div class="forgot-pw-header mb-1">
                                    <a class="back" style={{cursor: 'pointer'}} href="" onClick={props.goBack}>&#8592;</a>
                                </div>
                                <div class="content p-3">
                                    <h1 class="h5"><i class="bky-help p-1 mr-2"></i> 
                                        {props.sheetData.ForgetPassword}
                                    </h1>
                                <Alert
                                        success = {props.success}
                                        error = {props.error}
                                        msg = {props.msg}
                                    />
                                {props.successPass && 
                                    <div className="alert-success">
                                        <p>{props.sheetData.password_sent}</p>
                                    </div>
                                }
                                {props.invalidEmail && 
                                    <div className="alert-danger">
                                        <p>{props.sheetData.contact_fragment_email_validation_error}</p>
                                    </div>
                                }
                                <hr class="divider1"/>
                                    <p>{props.sheetData.forgetPasswod_msg_one}</p>
                                    <form onSubmit={props.forgetPassSubmit}>
                                        <div class="form-group mb-3">
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                id="floatingInput" 
                                                name = "username" 
                                                value = {props.formData.username}
                                                onChange={props.handleChange}
                                                placeholder="gl@blinkay.com" autoFocus
                                            ></input>
                                        </div>
                                            <p>
                                                <small>{props.sheetData.forgetPasswod_msg_two}</small>
                                            </p>
                                        <div class="text-center">
                                            <button type = "submit" className = "w-100 btn btn-lg bk-btn-primary mt-5">
                                                {props.sheetData.Request}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </section>
                        }

                        {/* Forget Password Form */}

                    </main>
                </div>

                {/* Login */}

            </>
        )
}